/* Hero slider init for every .sah-hero instance (lazy, non-blocking) */
(function(){
  const rqIdle = window.requestIdleCallback || (cb => setTimeout(cb, 1));
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function applyDotColors(root, paginatorSel) {
    const useColored = root.dataset.coloredDotsMobile === 'true';
    if (!useColored) return;
    const perSlide = root.dataset.dotsUsePerSlideColor === 'true';
    const inactiveOpacity = parseFloat(root.dataset.dotsInactiveOpacity || '0.6');
    const activeScale = parseFloat(root.dataset.dotsActiveScale || '1.4');

    const bullets = root.querySelectorAll(paginatorSel + ' .swiper-pagination-bullet');
    const slides = root.querySelectorAll('.swiper-slide');
    bullets.forEach((b, i) => {
      const color = (perSlide && slides[i]) ? (slides[i].getAttribute('data-dot') || '#29ABE2') :
        getComputedStyle(root).getPropertyValue('--dot-active').trim() || '#29ABE2';
      b.style.background = color;
      b.style.opacity = inactiveOpacity;
      b.style.transform = 'scale(1)';
    });
    const active = root.querySelector(paginatorSel + ' .swiper-pagination-bullet-active');
    if (active) {
      active.style.opacity = '1';
      active.style.transform = 'scale(' + activeScale + ')';
    }
  }

  function initOne(root){
    if (root.dataset.initialized === '1') return;
    if (!window.Swiper) return; // Swiper must be loaded by theme

    const sliderSel = '#' + root.querySelector('.home-slider').id;
    const paginatorSel = '.' + root.querySelector('.swiper-pagination').classList[0];
    const prevBtn = root.querySelector('.swiper-nav.prev');
    const nextBtn = root.querySelector('.swiper-nav.next');

    const autoplayEnabled = (root.dataset.autoplay === 'true') && !prefersReduced;
    const delay = parseInt(root.dataset.interval || '6', 10) * 1000;

    const swiper = new Swiper(sliderSel, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      spaceBetween: 0,
      loop: root.dataset.loop === 'true',
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      // rtl handled by CSS dir, Swiper is layout-agnostic in fade mode
      navigation: nextBtn && prevBtn ? { nextEl: nextBtn, prevEl: prevBtn } : undefined,
      pagination: { el: paginatorSel, clickable: true },
      a11y: { enabled: true },
      autoplay: autoplayEnabled ? { delay, disableOnInteraction: false, pauseOnMouseEnter: true } : false
    });

    const recolor = () => applyDotColors(root, '.' + root.querySelector('.swiper-pagination').classList[0]);
    swiper.on('init', recolor);
    swiper.on('slideChange', recolor);
    setTimeout(recolor, 0);

    document.addEventListener('visibilitychange', () => {
      if (!swiper.autoplay) return;
      if (document.hidden) swiper.autoplay.stop(); else swiper.autoplay.start();
    }, { passive:true });

    root.dataset.initialized = '1';
  }

  function lazyInit(root){
    if (!('IntersectionObserver' in window)) { rqIdle(() => initOne(root)); return; }
    const el = root.querySelector('.home-slider');
    if (!el) return;
    let started = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && e.intersectionRatio >= 0.25 && !started) {
          started = true;
          io.disconnect();
          rqIdle(() => initOne(root));
        }
      });
    }, { threshold: [0, 0.25, 0.5] });
    io.observe(el);
  }

  function boot(){
    document.querySelectorAll('.sah-hero').forEach(lazyInit);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') boot();
  else document.addEventListener('DOMContentLoaded', boot, { once:true });

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      // in case pagination styles need re-apply after BFCache
      document.querySelectorAll('.sah-hero').forEach(root => {
        rqIdle(() => applyDotColors(root, '.' + root.querySelector('.swiper-pagination').classList[0]));
      });
    }
  });
})();
